var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2 text-right"},[_vm._t("default"),(!_vm.ocultarCancelar)?_c('b-button',{staticClass:"ml-2",attrs:{"type":"button","variant":"secondary"},on:{"click":_vm.confirmarCancelacion}},[_vm._v(" Cancelar ")]):_vm._e(),_c('b-button',{staticClass:"ml-2",attrs:{"type":"submit","variant":"primary"}},[_vm._v(" Aceptar ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }